import React, { useState, useEffect } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

function DefaultLoading({
  text = "",
  className = "",
  delay = 200,
  width = "w-full",
  height = "h-32"
}) {
  const [showLoading, setShowLoading] = useState(false);
  const [dots, setDots] = useState("");

  useEffect(() => {
    // Only show loading indicator after the specified delay
    const timer = setTimeout(() => {
      setShowLoading(true);
    }, delay);

    // Clean up timer on unmount
    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (text && showLoading) {
      // Create dots animation for text
      const interval = setInterval(() => {
        setDots(prev => {
          if (prev.length >= 3) return "";
          return prev + ".";
        });
      }, 500);

      return () => clearInterval(interval);
    }
  }, [text, showLoading]);

  // Return null during the delay period
  if (!showLoading) {
    return null;
  }

  // When text is provided, show animated text
  if (text) {
    return (
      <div className={`flex items-center justify-center ${className} ${width} ${height}`}>
        <p className="text-base font-medium text-center animate-pulse">
          {text}<span className="inline-block w-6">{dots}</span>
        </p>
      </div>
    );
  }

  // When no text is provided, show skeleton
  return (
    <div className={`${width} ${height} rounded-lg overflow-hidden border border-border ${className}`}>
      <div className="p-4 flex flex-col gap-3">
        {/* Avatar and name row */}
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-3 w-16" />
          </div>
        </div>
        
        {/* Contact details */}
        <div className="space-y-2 mt-2">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      </div>
    </div>
  );
}

export default DefaultLoading;